import logo from './logo/kagami.png'
import epsLogo from './logo/epsLogo.png'
import eisLogo from './logo/eisLogo.png'
import EHIS from './EHIS.png'
import MIS from './MIS.svg'
import middletonLogo from './logo/middletonLogo.png'
import macControl from './image/macButton.png'
import edit from './icon/edit.png'
import editSvg from './icon/edit.svg'
import student from './icon/student.svg'
import empty from './image/empty.png'
import user from './Vector15.png'
import school from './Vector16.png'
import grid from './Vector17.png'
import mark from './Vector18.png'
import logoIcon from './Vector20.png'
import checked from './Vector21.png'
import notFound from './notfound.png'
import boy from './boy.png'
import like from './like.gif'
import love from './love.gif'
import wow from './oo.gif'
import funny from './funny.gif'
import sad from './sad.gif'
import videoThumb from './video-thumbnail.png'
import pdfThumb from './pdf-thumbnail.png'
import likeThumb from './icon/like.png'
import emptyThumb from './empty-img.png'
import recommendIcon from './icon/recommendation.png'
import chinaBank from './image/paymentIcon/china.png'
import citiBank from './image/paymentIcon/citbank.png'
import dbsBank from './image/paymentIcon/dbs.png'
import hsbcBank from './image/paymentIcon/hsbc.png'
import icbcBank from './image/paymentIcon/icbc.png'
import maybank from './image/paymentIcon/maybank.png'
import ocbcBank from './image/paymentIcon/ocbc.png'
import posbBank from './image/paymentIcon/posb.png'
import standardBank from './image/paymentIcon/standard.png'
import uobBank from './image/paymentIcon/uob.jpg'
import creditCardPayment from './image/paymentIcon/creditcardlogo.png'
import cardUp from './image/paymentIcon/cardup.png'
import cardUpWhite from './image/paymentIcon/cardupWhite.png'
import paymentCreditCard from './icon/paymentCreditCard.svg'
import bankTransfer from './icon/bank-transfer.svg'
import appLanding from './notFound/appLanding.jpg'
import appStore from './notFound/appStore.png'
import playStore from './notFound/playStore.png'
import appMobileLanding from './notFound/appMobileLanding.jpg'
import appLandingLogo from './notFound/appLandingLogo.jpg'
import mediaDownload from './icon/mediaDownload.png'

const assets = {
  image: {
    logo,
    epsLogo,
    eisLogo,
    middletonLogo,
    macControl,
    empty,
    notFound,
    boy,
    logoIcon,
    checked,
    videoThumb,
    emptyThumb,
    pdfThumb,
    appLanding,
    appStore,
    playStore,
    appMobileLanding,
    appLandingLogo,
  },
  icon: {
    edit,
    student,
    editSvg,
    user,
    school,
    grid,
    mark,
    likeThumb,
    recommendIcon,
    paymentCreditCard,
    bankTransfer,
  },
  emotion: {
    like,
    love,
    sad,
    wow,
    funny,
  },
  bank: {
    chinaBank,
    citiBank,
    dbsBank,
    hsbcBank,
    icbcBank,
    maybank,
    ocbcBank,
    posbBank,
    standardBank,
    uobBank,
    creditCardPayment,
    cardUp,
    cardUpWhite,
  },
  activity: {
    mediaDownload,
  },
  application: {
    EHIS,
    MIS,
  },
}

export default assets
